module.exports = __webpack_public_path__ + "first-500_glossy_number.jpg?72638fef0ddf6b73b01aea77e05781ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_glossy_number.jpg
// module id = 554
// module chunks = 0